import React from 'react'
import styles from './welcome.module.css'
import { ReactComponent as Check } from '../../assets/images/wkit/check.svg';
import { ReactComponent as Medal } from '../../assets/images/wkit/medal.svg';
import { ReactComponent as WhatsApp } from '../../assets/images/wkit/social-media-whatsapp.svg';
import { ReactComponent as Calling } from '../../assets/images/wkit/calling.svg';
import { ReactComponent as Email } from '../../assets/images/wkit/email.svg';

import { useTranslation } from "react-i18next";
import moment from 'moment';

const HeadComponent = ({ email, policyNumber, productName, policyDate, sadadBill, type, sadadExp }) => {
    const today = moment().add(0, "d").format("DD/MM/YYYY");

    const { t } = useTranslation();

    const handleCallcenterClick = () => {
        window.open("tel:966920019990");
    };

    const handleStartLiveChat = () => {
        window.open("https://wa.me/00966920019990");
    };

    const handlemailtoClick = () => {
        window.open("mailto:Care@tawuniya.com.sa");
    };
console.log(type,"type")
    const renderContent = () => {
        switch (type) {
            case "credit":
                return (
                    <div className={styles.wrapper}>
                        <div className={styles.paymentInfo}>
                            <Check />
                            <h3 className={styles.heading}>{t("SuccessKit.WeAre")}</h3>
                            <h3 className={styles.info}>{t("SuccessKit.Thank")} {productName ? productName : ""} {t("SuccessKit.withTawuniya")}
                                {t("SuccessKit.YourPolicy")} {policyNumber ? policyNumber : "####"} {t("SuccessKit.coverage")} {policyDate ? policyDate : today}.
                            </h3>
                            <span className={styles.span}>{t("SuccessKit.policy")} {email ? email : ""}</span>
                        </div>
                    </div>
                );
            case "sadad":
                return (
                    <div className={styles.wrapper}>
                        <div className={styles.paymentInfo}>
                            <Check />
                            <h3 className={styles.heading}>{t("SuccessKit.WelcomeSdad")}</h3>
                            <div>
                                <h3 className={styles.head}>{t("SuccessKit.refrence")}</h3>
                                <p className={styles.bill}>{t("SuccessKit.refNum")}: {sadadBill}</p>
                                <p className={styles.bill}>{t("SuccessKit.biller")}: [003]</p>
                            </div>
                            <div>
                                <h3 className={styles.head}>{t("SuccessKit.Note")}</h3>
                                <p className={styles.bill}>{t("SuccessKit.sdadData")} {sadadExp}</p>
                                <p className={styles.bill}>{t("SuccessKit.banks")}</p>
                            </div>
                        </div>
                        {/* {systemId==="MOTOR" && <HomeInsurancePromoMsg text={t('HomeInsurancePromoMsgSadad')}/>} */}

                    </div>
                );

            default:
                return (
                    <div className={styles.wrapper}>
                        <div className={styles.paymentInfo}>
                            <Check />
                            <h3 className={styles.heading}>{t("contactUs.inq_success.reach_you")}</h3>
                            <h3 className={styles.heading}>{t("contactUs.inq_success.thanks_for_touch")}</h3>
                            <span className={styles.span}>{t("contactUs.inq_success.your_patience")}</span>
                        </div>
                    </div>
                );
        }
    }

    return renderContent();
}

export default HeadComponent;
